export class Color {
    public color: string;

    constructor(color: string) {
        this.color = color;
    }
}
